import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { OkResponse } from "@typings/api";
import type { CreateAttachmentsDTO } from "@typings/entities/attachments";

export async function createAttachmentsIndividual(
  attachments: CreateAttachmentsDTO,
): Promise<OkResponse> {
  const formData = new FormData();
  attachments.files.forEach((file) => formData.append("media", file));

  const response = await apiClient.post<OkResponse>(
    apiPaths.individuals.createAttachments(attachments.id),
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );

  return response.data;
}
